import React from "react";
import { BillIcon } from "../../../icons";
import { BillActivity } from "../../../api/services";
import { ActivityListItem } from "./ActivityListItem";
import { ActivityTitle } from "./ActivityTitle";
import { useBillActivity } from "../hooks/useBillActivity";
import { ActivitySummaryCell } from "./ActivitySummaryCell";

export const BillActivityItem: React.FC<{
  activity: BillActivity;
}> = ({ activity }) => {
  const { title, billPeriod, link } = useBillActivity(activity);
  return (
    <ActivityListItem
      icon={<BillIcon />}
      title={
        <ActivityTitle whiteSpace="nowrap">
          {title}
          {`Period ${billPeriod}`}
        </ActivityTitle>
      }
      activityDttm={activity.activityDttm}
      linkTo={link}
    />
  );
};

export const BillActivitySummaryCell: React.FC<{
  activity: BillActivity;
  isGrey: boolean;
}> = ({ activity, isGrey }) => {
  const { title, billPeriod } = useBillActivity(activity);
  return (
    <ActivitySummaryCell
      isGrey={isGrey}
      icon={<BillIcon />}
      summary={`${title} (Period ${billPeriod})`}
    />
  );
};
